import React from "react";
import PropTypes from "prop-types";

import Card from "components/Card";

import searchIcon from "components/assets/images/search--light.svg";
import crossIcon from "components/assets/images/close--light.svg";
import "./SearchBar.css";

export default class SearchBar extends React.Component {
  
  static propTypes = {
    query: PropTypes.string,
    onSearch: PropTypes.func.isRequired
  }
  
  static defaultProps = {
    query: ""
  }
  
  clearQuery = () => {
    this.props.onSearch("");
  }
  
  onChange = (changeEvent) => {
    const { value } = this.textInput;
    this.props.onSearch(value);
  }

  refTextInput = (textInput) => {
    this.textInput = textInput;
  }

  render() {
    
    const { query } = this.props;
    const hasQuery = query !== "";
    
    return (
      <div className="search-bar-container">
        <Card>
          <Card.Body>
            <div className="search-bar">
              <input className="search-bar__input" value={query} ref={this.refTextInput} onChange={this.onChange} placeholder="Search" />
              <div className="search-bar__action">
                {
                  hasQuery ?
                  <div onClick={this.clearQuery}>
                    <img src={crossIcon} alt="clear" />
                  </div> :
                  <img src={searchIcon} alt="search" />
                }
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
    
  }

}



// WEBPACK FOOTER //
// ./src/components/SearchBar.js